import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import ConnexionForm from "../ConnexionForm";
import SignupForm from "../SignupForm";
import ForgetPassword from "../ForgetPassword";
import VerificationCode from "./VerificationCode/VerificationCode";

import { resetLogin, facebookOrGoogleSignIn } from "../../redux/actions";

import { UNIT } from "../../constants/configuration";
import styles from "./SignInSignUpContainer.styles";
import { isDarkTheme } from "../../utils";

import {
  handleConnectionService,
  handleSignupService,
  handleForgetPasswordService,
  handleVerifyCodeService,
  resendCodeService,
} from "./SignInSignUpContainer.services";
import { verificationCodeService } from "./VerificationCode/VerificationCode.services";
export default function SignInSignUpContainer() {
  const dispatch = useDispatch();

  const [password, setPassword] = useState("");
  const [verificationError, setVerificationError] = useState("");
  const [loading, setLoading] = useState(false);
  const [time, setTime] = useState(verificationCodeService.resetTimer());
  const { signUp, showForgetPassword } = useSelector(
    (state) => state.componentReducer,
  );

  const {
    userSignupError,
    userConnectionError,
    resetPasswordError,
    requireVerification,
    verificationEmail,
  } = useSelector((state) => state.userReducer);

  const { secondaryColor } = useSelector((state) => state.configurationReducer);

  useEffect(() => {
    dispatch(resetLogin());
  }, [dispatch]);

  const handleConnection = useCallback(
    (email, password) => {
      handleConnectionService(
        dispatch,
        email,
        password,
        setPassword,
        setVerificationError,
      );
    },
    [dispatch],
  );

  const handleSignup = useCallback(
    (email, password, nom, prenom, telephone, phoneObj, newsletter) => {
      handleSignupService(
        dispatch,
        email,
        password,
        nom,
        prenom,
        telephone,
        phoneObj,
        newsletter,
      );
    },
    [dispatch],
  );

  const handleForgetPassword = useCallback(
    (email) => {
      handleForgetPasswordService(dispatch, email);
    },

    [dispatch],
  );

  const handleVerifyCode = useCallback(
    (code) => {
      handleVerifyCodeService(
        dispatch,
        verificationEmail,
        password,
        code,
        setVerificationError,
        setLoading,
        setTime,
      );
    },

    [dispatch, verificationEmail, password],
  );

  const sendNewCode = () => {
    resendCodeService(
      dispatch,

      verificationEmail,

      password,
    );
  };

  const renderContent = () => {
    if (requireVerification) {
      return (
        <VerificationCode
          onClearError={() => setVerificationError("")}
          email={verificationEmail}
          secondaryColor={secondaryColor}
          dark={isDarkTheme()}
          onVerify={handleVerifyCode}
          errorMessage={verificationError}
          onResend={sendNewCode}
          loading={loading}
          setTime={setTime}
          time={time}
        />
      );
    }

    if (signUp && !showForgetPassword) {
      return (
        <div className="col-12 text-center" style={styles.space}>
          <p
            className="title2 label"
            style={{
              marginBottom: UNIT,
            }}
          >
            Terminer l'inscription
          </p>

          <SignupForm onSubmit={handleSignup} errorMessage={userSignupError} />
        </div>
      );
    }

    if (showForgetPassword) {
      return (
        <div className="col-12 text-center">
          <h3>Réinitialiser votre mot de passe</h3>

          <ForgetPassword
            onSubmit={handleForgetPassword}
            errorMessage={resetPasswordError}
          />
        </div>
      );
    }

    return (
      <div className="col-12 text-center" style={styles.space}>
        <div
          style={{
            width: `${UNIT * 5}%`,
          }}
        >
          <p className="text-left title label">
            Créer un compte ou se connecter
          </p>
        </div>

        <ConnexionForm
          onSubmit={handleConnection}
          facebookOrGoogleSignIn={facebookOrGoogleSignIn}
          errorMessage={userConnectionError}
        />
      </div>
    );
  };

  return (
    <div className="container-fluid p-2">
      <div className="row">{renderContent()}</div>
    </div>
  );
}
